import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Transaction } from '@/types';

interface TransactionState {
  transactions: Transaction[];
  isLoading: boolean;
  error: string | null;
}

const initialState: TransactionState = {
  transactions: [],
  isLoading: false,
  error: null,
};

const transactionSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    addTransaction: (state, action: PayloadAction<Transaction>) => {
      state.transactions.unshift(action.payload);
    },
    updateTransaction: (state, action: PayloadAction<{ hash: string; status: Transaction['status'] }>) => {
      const index = state.transactions.findIndex(tx => tx.hash === action.payload.hash);
      if (index !== -1) {
        state.transactions[index].status = action.payload.status;
      }
    },
    setTransactions: (state, action: PayloadAction<Transaction[]>) => {
      state.transactions = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  addTransaction,
  updateTransaction,
  setTransactions,
  setLoading,
  setError,
} = transactionSlice.actions;

export default transactionSlice.reducer; 